<template>
    <div>
        <a
            v-if="playerDownloadWindowsExe || playerDownloadWindowsMsiWrapped"
            :href="playerDownloadWindowsExe ?? playerDownloadWindowsMsiWrapped"
            class="btn btn-sm d-flex align-items-center justify-content-center text-nowrap ml-0"
            :class="{ 'btn-primary': currentPlatform === PLATFORMS.WINDOWS || !currentPlatform, 'btn-secondary': currentPlatform && currentPlatform !== PLATFORMS.WINDOWS }"
            target="_blank"
            :title="$t('theme.download_windows_long')"
            v-tooltip="$t('theme.download_windows_long')"
        >
            <icon name="brands/windows" class="mr-2" />
            {{ $t('theme.download_windows') }}
        </a>

        <div class="alternative-downloads" v-if="playerDownloadWindowsExe && playerDownloadWindowsMsiWrapped">
            <a :href="playerDownloadWindowsExe">Download .exe</a>
            <span> | </span>
            <a :href="playerDownloadWindowsMsiWrapped">Download .msi</a>
        </div>

        <a
            v-if="playerDownloadMacOS"
            :href="playerDownloadMacOS"
            class="btn btn-sm d-flex align-items-center justify-content-center mt-2 ml-0 text-nowrap"
            :class="{ 'btn-primary': currentPlatform === PLATFORMS.MACOS || !currentPlatform, 'btn-secondary': currentPlatform && currentPlatform !== PLATFORMS.MACOS }"
            target="_blank"
            :title="$t('theme.download_macos_long')"
            v-tooltip="$t('theme.download_macos_long')"
        >
            <icon name="brands/apple" class="mr-2" />
            {{ $t('theme.download_macos') }}
        </a>

        <a
            v-if="playerDownloadLinux"
            :href="playerDownloadLinux"
            class="btn btn-sm d-flex align-items-center justify-content-center mt-2 ml-0 text-nowrap"
            :class="{ 'btn-primary': currentPlatform === PLATFORMS.LINUX, 'btn-secondary': currentPlatform !== PLATFORMS.LINUX || !currentPlatform }"
            target="_blank"
            :title="$t('theme.download_linux_long')"
            v-tooltip="$t('theme.download_linux_long')"
        >
            <icon name="brands/linux" class="mr-2" />
            {{ $t('theme.download_linux') }}
        </a>
    </div>
</template>
<script setup>

    import { computed } from 'vue';
    import { PLATFORMS } from '../enums/platforms';
    import { detectCurrentPlatform } from '../utils/platform';

    const playerDownloadWindowsExe = computed(() => window.PLAYER_DOWNLOAD_PATH_WINDOWS_EXE);
    const playerDownloadWindowsMsiWrapped = computed(() => window.PLAYER_DOWNLOAD_PATH_WINDOWS_MSI_WRAPPED);
    const playerDownloadLinux = computed(() => window.PLAYER_DOWNLOAD_PATH_LINUX);
    const playerDownloadMacOS = computed(() => window.PLAYER_DOWNLOAD_PATH_MACOS);

    const currentPlatform = computed(() => detectCurrentPlatform());
</script>

<style lang="scss" scoped>
    .alternative-downloads {
        margin-bottom: 15px;

        a {
            font-size: 14px;
            color: #718096 !important;
        }
    }
</style>
